import { GET_TM_SHARED_SUB_TASKS } from "@actions/taskManagement/sharedSubTasks/types";

import {
  SharedSubTasksState,
  SharedSubTasksStateAction,
} from "@reducers/types/taskManagement/shared-sub-tasks-state";

export const initialState: SharedSubTasksState = {
  isGetLoading: false,
  isGetSingleLoading: false,
  isUpdateLoading: false,
  isDeleteLoading: false,
  isCreateLoading: false,

  getError: null,
  getSingleError: null,
  createError: null,
  updateError: null,
  deleteError: null,

  getSuccess: false,
  getSingleSuccess: false,
  createSuccess: false,
  updateSuccess: false,
  deleteSuccess: false,

  getData: null,
  getSingleData: null,
};

const sharedSubTasksReducer = (
  state: SharedSubTasksState = initialState,
  action: SharedSubTasksStateAction,
): SharedSubTasksState => {
  const { type, payload } = action;

  switch (type) {
    // fetch
    case GET_TM_SHARED_SUB_TASKS.LOADING:
      return {
        ...state,
        isGetLoading: payload,
        getSuccess: false,
        getError: null,

        getSingleSuccess: false,
        getSingleError: null,

        createSuccess: false,
        createError: null,

        updateSuccess: false,
        updateError: null,

        deleteSuccess: false,
        deleteError: null,
      };

    case GET_TM_SHARED_SUB_TASKS.ERROR:
      return {
        ...state,
        getError: payload,
        getData: null,
        isGetLoading: false,
      };

    case GET_TM_SHARED_SUB_TASKS.SUCCESS:
      return {
        ...state,
        getError: null,
        getData: payload,
        getSuccess: true,
        isGetLoading: false,
      };

    default:
      return state;
  }
};

export default sharedSubTasksReducer;
